import React from 'react'
import { Button, Col, Modal, Row, Spinner } from 'react-bootstrap'
import UseDeleteAddressUser from '../../CustomHooks/User/UseDeleteAddressUser'
import { ToastContainer } from 'react-toastify'
import UseEditAddressUser from '../../CustomHooks/User/UseEditAddressUser'
import DeletePopUp from '../Layout/DeletePopUp'

const UserAddressCard = ({ item }) => {
    const [HandleDeleteAddress, handleDeleteShow, handleDeleteClose, deleteShow] = UseDeleteAddressUser(item)
    const [isFormValid, loading, isPress, validateTitle, validateDetails, validatePhoneNumber, HandleEditAddress, handleEditShow, handleEditClose, EditShow, EditAddressTitle, changeEditAddressTitle, EditaddressInDetails, changeEditAddressInDetails, EditphoneNumber, changeEditPhoneNumber] = UseEditAddressUser(item)

    return (
        <div className="my-3 px-4 py-3 shadow">
            <DeletePopUp show={deleteShow} handleDeleteItem={HandleDeleteAddress} handleClose={handleDeleteClose} />
            {/* start Edit modal */}
            <Modal show={EditShow} onHide={handleEditClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Address</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Col sm="12">
                        <input
                            value={EditAddressTitle}
                            onChange={changeEditAddressTitle}
                            onBlur={validateTitle}
                            type="text"
                            className="form-control d-block mt-3 px-3 h-60"
                            placeholder="Address Name"
                        />
                        <textarea
                            value={EditaddressInDetails}
                            onChange={changeEditAddressInDetails}
                            onBlur={validateDetails}
                            className="form-control p-2 mt-3 h-200"
                            rows="4"
                            cols="50"
                            placeholder="Address in Details"
                        />
                        <input
                            value={EditphoneNumber}
                            onChange={changeEditPhoneNumber}
                            onBlur={validatePhoneNumber}
                            type="text"
                            className="form-control d-block mt-3 px-3 h-60"
                            placeholder="Phone Number"
                        />
                    </Col>
                </Modal.Body>
                <Modal.Footer >
                    <button className='btn orange-bg w-100 py-3 text-white' onClick={HandleEditAddress} disabled={!isFormValid}>
                        {isPress ? loading ? (<Spinner animation="border" variant="light" />) : (<span>Save</span>) : <span>Save</span>}
                    </button>
                </Modal.Footer>
            </Modal>
            {/* end Edit modal */}
            <Row className="d-flex justify-content-between">
                <Col lg="8" md="6" xs="12">
                    <p>{item.alias}</p>
                    <p> {item.details} </p> 
                    <p> {item.phone} </p>
                </Col>
                <Col lg="4" md="6" xs="12">
                    <Row>
                        <Col sm="6" xs="12">
                            <Button variant="warning" className='w-100 action-button mb-3 me-3 px-5' onClick={handleEditShow}>Edit</Button>
                        </Col>
                        <Col sm="6" xs="12">
                            <Button variant="danger" className='w-100 action-button mb-3 px-5' onClick={handleDeleteShow}>Delete</Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <ToastContainer />
        </div>
    )
}

export default UserAddressCard
